import axios from "axios";
import {
    ESApiFinalResponseInterface,
    ESApiResponseInterface,
} from "../interfaces/ElasticSearchInterface";
import { EnvironmentConfig } from "@me8eon/config";
import { JwtTokenFn } from "@me8eon/authentication";

export const getAppsSearchResults = async (
    searchTerm: string,
    esApiKey: JwtTokenFn
): Promise<ESApiFinalResponseInterface[]> => {
    const searchIndex = EnvironmentConfig.enhancedAppIndex;
    const apiKey = await esApiKey();

    const ELASTICSEARCH_URL = `${EnvironmentConfig.elasticSearchProxyUrl}/${searchIndex}/_search`;

    const excludeFields = [
        // ...blacklistedFields,
        "full_text_embeddings", 
        "vectorisation_model",
        "denied_countries",
        "denied_companies",
        "denied_users",
        "allowed_countries",
        "allowed_companies",
        "allowed_users",
        "allowed_all_countries",
        "allowed_all_companies",
        "allowed_all_users",
        "semantic_text",
        "semantic_test",
        "dense_vector",
        "sparse_vector",
    ];

    const normalizedSearchTerm = searchTerm.trim();
    const k = normalizedSearchTerm.length > 0 ? 5 : 100;
    const reqBody = normalizedSearchTerm
        ? {
              _source: {
                  excludes: excludeFields,
              },
              size: k,
              retriever: {
                  text_similarity_reranker: {
                      retriever: {
                          rrf: {
                              rank_window_size: 100,
                              rank_constant: 60,
                              retrievers: [
                                  {
                                      standard: {
                                          query: {
                                              match: {
                                                  sparse_vector:
                                                      normalizedSearchTerm,
                                              },
                                          },
                                      },
                                  },
                                  {
                                      standard: {
                                          query: {
                                              match: {
                                                  dense_vector:
                                                      normalizedSearchTerm,
                                              },
                                          },
                                      },
                                  },
                              ],
                          },
                      },
                      field: "semantic_text",
                      inference_id: "cross-encoder-rerank",
                      inference_text: normalizedSearchTerm,
                      rank_window_size: 5,
                  },
              },
              highlight: {
                  fields: {
                      sparse_vector: {
                          type: "semantic",
                          number_of_fragments: 3,
                          order: "score",
                      },
                      dense_vector: {
                          type: "semantic",
                          number_of_fragments: 3,
                          order: "score",
                      },
                  },
              },
          }
        : {
              _source: {
                  excludes: excludeFields,
              },
              size: k,
              query: {
                  match_all: {},
              },
          };

    try {
        const response = await axios.post(ELASTICSEARCH_URL, reqBody, {
            headers: {
                Authorization: `Bearer ${apiKey}`,
            },
        });
        const result: ESApiFinalResponseInterface[] =
            response.data.hits.hits.map((hit: ESApiResponseInterface) => {
                return {
                    ...hit._source,
                    highlight: hit.highlight,
                    index: hit._index,
                    score: hit._score,
                };
            });
        return result;
    } catch (error) {
        console.error("Error fetching apps search results:", error);
        return [];
    }
};
